export enum ResponseType {
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'application/csv',
  TXT = 'text/plain',
  TXT_UTF8 = 'text/plain;charset=utf-8',
  ZIP = 'application/zip',
}
